import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PageHeader from "../../components/common/PageHeader";
import useUserManagement from "./hooks/useUserManagement";
import UserForm from "./components/UserForm";
import UserTable from "./components/UserTable";
import EditUserModal from "./components/EditUserModal";
import DeleteConfirmModal from "./components/DeleteConfirmModal";

const UserManagement = () => {
  const {
    form, errors, loading,
    search, setSearch,
    page, setPage, totalPages, rowsPerPage,
    filteredUsers, paginatedUsers,
    editOpen, setEditOpen, editForm, setEditForm,
    deleteOpen, setDeleteOpen, selectedUser,
    handleFormChange, handleRoleChange, handleSubmit,
    handleEditClick, handleEditSubmit,
    handleDeleteClick, confirmDelete,
    getInitials,
  } = useUserManagement();

  return (
    <div>
      <ToastContainer position="top-center" autoClose={3000} />

      <PageHeader
        showBackButton={true}
        backTo={-1}
        title="User Management"
        subtitle="Add and manage system users"
      />

      <div className="space-y-5">
        <UserForm
          form={form}
          errors={errors}
          handleFormChange={handleFormChange}
          handleRoleChange={handleRoleChange}
          handleSubmit={handleSubmit}
        />

        <UserTable
          paginatedUsers={paginatedUsers}
          filteredUsers={filteredUsers}
          search={search}
          setSearch={setSearch}
          loading={loading}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          getInitials={getInitials}
          onEdit={handleEditClick}
          onDelete={handleDeleteClick}
        />
      </div>

      <EditUserModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        editForm={editForm}
        setEditForm={setEditForm}
        onSubmit={handleEditSubmit}
      />

      <DeleteConfirmModal
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        user={selectedUser}
        onConfirm={confirmDelete}
      />
    </div>
  );
};

export default UserManagement;
